// Shared search input + matching helper for the Assignment + Timeline
// toolbars. Filters driver rows by anything the dispatcher might type:
// driver name, badge, seniority, shift code, flight number, origin
// city, inbound gate, role label, or any outbound stop's flight #,
// destination, or gate.

import React from 'react';
import { Box, InputBase, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { C } from './styles';

function lc(v) { return v == null ? '' : String(v).toLowerCase(); }

// Returns true when the search query matches any field on the driver
// or any of their assigned runs. Empty query → match everything.
export function rowMatchesQuery(query, driver, slots) {
  const q = (query || '').trim().toLowerCase();
  if (!q) return true;
  if (lc(driver.displayName).includes(q)) return true;
  if (lc(driver.badge).includes(q)) return true;
  if (lc(driver.seniority).includes(q)) return true;
  if (lc(driver.shiftCode).includes(q)) return true;
  for (const run of slots) {
    if (!run) continue;
    if (lc(run.inboundFlightNumber).includes(q)) return true;
    if (lc(run.inboundFrom).includes(q)) return true;
    if (lc(run.inboundGate).includes(q)) return true;
    if (lc(run.slotLabel).includes(q)) return true;
    for (const stop of run.stops || []) {
      if (lc(stop.destination).includes(q)) return true;
      if (lc(stop.flightNumber).includes(q)) return true;
      if (lc(stop.gate).includes(q)) return true;
    }
  }
  return false;
}

export function SearchInput({ value, onChange, placeholder = 'Search driver, flight, gate…' }) {
  const active = (value || '').trim().length > 0;
  return (
    <Box sx={{
      display: 'flex', alignItems: 'center',
      backgroundColor: C.surfaceAlt,
      border: `1px solid ${active ? C.accent : C.border}`,
      borderRadius: 1,
      px: 0.75, py: 0.25,
      transition: 'border-color 120ms',
      minWidth: 200,
      '&:hover': { borderColor: active ? C.accent : C.borderStrong },
      '&:focus-within': { borderColor: C.accent },
    }}>
      <SearchIcon sx={{ fontSize: 16, color: active ? C.accent : C.textMuted, mr: 0.5 }} />
      <InputBase
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        sx={{
          flex: 1, fontSize: '0.8rem', color: C.textPrimary,
          '& input::placeholder': { color: C.textMuted, opacity: 1 },
        }}
      />
      {active && (
        <IconButton size="small" onClick={() => onChange('')} sx={{ p: 0.25, color: C.textMuted, '&:hover': { color: C.accent } }}>
          <CloseIcon sx={{ fontSize: 14 }} />
        </IconButton>
      )}
    </Box>
  );
}
